module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-button-recharge",
    class: [_vm.disabled ? 'btn-disabled' : '', _vm.commend ? 'commend' : '']
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.desc))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d7237a4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/public-lib/vue-components/src/components/c-button/recharge/index.vue
// module id = 367
// module chunks = 0